import { css } from "@emotion/react";

export const mainContainer = css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: absolute;
    background-color: white;
    box-shadow: 10px 10px 4px rgba(0,0,0,0.4);
    border-radius: 3px;
    border: 1px solid #cccccc;
    bottom: 12px;
    min-width: 160px;
    transform: translateX(-50%);

    &::after, &::before {
        top: 100%;
        border: solid transparent;
        content: " ";
        left: 90px;
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }

    &::after {
        border-top-color: white;
        border-width: 10px;
        margin-left: -10px;
    }

    &::before {
        border-top-color: #cccccc;
        border-width: 11px;
        margin-left: -11px;
    }
`

export const top = css`
    width: 100%;
    height: 15px;
    border-radius: 3px 3px 0px 0px;
    background-color: #004F9E;
`

export const closer = css`
    font-size: 12px;
    text-decoration: none;
    position: absolute;
    top: 2px;
    right: 5px;
    cursor: pointer;
    color: white;
`

export const content = css`
    display: flex;
    width: 100%;
    align-self: flex-start;
    justify-content: flex-start;
    padding: 10px 10px 20px 10px;
    flex-direction: column;
    white-space: nowrap;
`

export const header = css`
    font-size: 15px;
    width: 160px;
    font-weight: bold;
    padding-bottom: 10px;
    color: #002755;
    border-bottom: 1px solid #dbdbdb;
`

export const name = css`
    padding-top: 10px;
    font-size: 13px;
    padding-bottom: 5px;
`

export const text = css`
    font-size: 12px;
`
